import { OrderStates } from './order.states';

export class OrderScroll extends OrderStates {
  scrollToInvalidInput() {
    const isXlQuery = window.matchMedia('(min-width: 1281px)').matches;
    const form = this.order.querySelector(`[data-step="${this.TAB_STATES.step}"] form`);
    const invalidInput = form?.querySelector(':invalid');

    const yOffset = -250;

    if (invalidInput !== null && !isXlQuery) {
      this.scrollWithOffset(yOffset, invalidInput.getBoundingClientRect().top);
    }

    return this;
  }

  scrollWithOffset(offset, pos) {
    const y = pos + window.pageYOffset + offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return this;
  }

  scrollToFormOnMobile() {
    const form = this.order.querySelector(`[data-step="${this.TAB_STATES.step}"] form`);
    const yOffset = -250;

    if (window.matchMedia('(max-width: 480px)').matches) {
      const y = form.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    return this;
  }
}
